export function format(seconds: number): string {
    const date = new Date(0, 0, 0, 0, 0, seconds);

    return new Intl.DateTimeFormat("en-GB", {
        hour: seconds >= 3600 ? "numeric" : undefined,
        minute: "numeric",
        second: "numeric",
    }).format(date);
}

interface DurationProps {
    className?: string;
    seconds: number;
    ariaLabel: string;
}

const Duration = ({ className, seconds, ariaLabel }: DurationProps) => {
    return (
        <time dateTime={`P${Math.round(seconds)}S`} className={className} aria-label={ariaLabel}>
            {format(seconds)}
        </time>
    );
};

export default Duration;
